<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="sysWorkDayViewInfo"
                        :filter_language="['StatusName']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column show-overflow-tooltip prop="Work_Day_Code" :label="$t('getapi[4089]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="StatusName" :label="$t('getapi[552]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4044]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <el-button type="primary" size="mini" @click="audit(1)" :disabled="dataDetail.Enable_Flag == 1">{{$t('getapi[4094]')}}</el-button>
                    <el-button type="primary" size="mini" @click="audit(0)" :disabled="dataDetail.Enable_Flag != 1">{{$t('getapi[4093]')}}</el-button>
                </div>
                <table>
                    <tr>
                        <td>
                            <span>{{$t('getapi[4089]')}}</span>
                        </td>
                        <td>
                            <el-input v-model="dataDetail.Work_Day_Code" :readonly="dataDetail.Enable_Flag == 1" :class="{'readO':dataDetail.Enable_Flag == 1}"></el-input>
                        </td>
                        <td>
                            <span>{{$t('getapi[552]')}}</span>
                        </td>
                        <td>
                            <el-input :value="dataDetail.Enable_Flag == 1?$t('getapi[1170]'):$t('getapi[1171]')"></el-input>
                        </td>
                    </tr>
                </table>
                <el-button type="primary" size="mini" @click="addLine" :disabled="dataDetail.Enable_Flag == 1">{{$t('getapi[6708]')}}</el-button>
                <el-button type="primary" size="mini" @click="delLine" :disabled="!btn.batchdel">{{$t('getapi[40]')}}</el-button>
                <el-table
                        id="xdetilpane-0"
                        :data="dataDetail.line"
                        ref="singleTable"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight-80"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        @selection-change="handleSelectionChange"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="Shift_period_name" :label="$t('getapi[4091]')" width="120">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.Shift_period_name" type="text" v-if="dataDetail.Enable_Flag != 1"></el-input>
                            <span v-if="dataDetail.Enable_Flag == 1">{{scope.row.Shift_period_name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Start_Time" :label="$t('getapi[4056]')" width="120">
                        <template slot-scope="scope">
                            <el-date-picker v-model="scope.row.Start_Time" type="datetime"
                                            format="HH:mm" :readonly="dataDetail.Enable_Flag == 1" :class="{'readO':dataDetail.Enable_Flag == 1}" @change="getMyDate(scope,1)" style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="End_Time" :label="$t('getapi[4057]')" width="120">
                        <template slot-scope="scope">
                            <el-date-picker v-model="scope.row.End_Time" type="datetime"
                                            format="HH:mm" :readonly="dataDetail.Enable_Flag == 1" :class="{'readO':dataDetail.Enable_Flag == 1}" @change="getMyDate(scope,2)" style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="sysWorkDayViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[3985]')" queryData="sysWorkDayViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_workdayview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_workdayview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {},
                code: '',
                addoredit: 1,
                selectData: [],
                btn: {
                    batchdel: false
                },
                timeId: null,
                scrollTop:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            'dataDetail.line': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.$limits.dragControllerDiv();
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('sysWorkDayViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3985]"),this.$t("getapi[27]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 169, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 169, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 171, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 171, 1) == 2) {
                        if (that.$limits.authority('plv3', 171,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 171,1) == 1) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                        if (that.$limits.authority('plv3', 171, 1) == 2) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.batchdel = false
                if(that.dataDetail.Enable_Flag == 0){
                    if(that.selectData.length > 0){
                        that.btn.batchdel = true
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_workdayview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            tableRowClassName({row, rowIndex}){
                row.index = rowIndex;
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'sysWorkDayViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Basic/WH/GetSys_Work_DayList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.Work_Day_Code){
                    return
                }
                that.timeId = setTimeout(() => {
                    that.code = row.Work_Day_Code
                    that.getDetail(that.code)
                }, 100);
            },
            // 获取详情数据
            getDetail(shirftcode) {
                let that = this
                that.addoredit = 2
                let parm = {
                    shift_code: shirftcode
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Basic/WH/GetShiftInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this
                that.openEdit()
                that.confirmAdd()
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.addoredit = 1
                that.code = ''
                that.dataDetail = {
                    Work_Day_Code:'',
                    Enable_Flag:'',
                    Create_Person:that.user,
                    Create_Time:datetime,
                    Audit_Person:"",
                    Audit_Time:"",
                    line:[]
                }
                that.authority()
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView()
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Basic/WH/GetSys_Work_DayListExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "sysWorkDayViewInfo",
                    fromname: that.$t('getapi[3985]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 审核反审
            audit(val){
                let that = this
                let parm = {
                    shift_code: that.dataDetail.Work_Day_Code,
                    Enable_Flag: val
                }
                that.$http.urlpost('/Basic/WH/ChangeShiftStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 添加明细
            addLine(){
                let that = this
                if(that.dataDetail.Work_Day_Code == ''){
                    that.$message.warning(that.$t('getapi[4099]'))//'请输入班制！'
                    return
                }
                that.dataDetail.line = [...that.dataDetail.line,{
                    Exclusively_ID:'',
                    Relation_Work_Day_Code:that.dataDetail.Work_Day_Code,
                    Shift_period_name:'',
                    Start_Time:'',
                    End_Time:''
                }]
            },
            // 保存
            save(){
                let that = this
                if(that.addoredit == 1){
                    let parm = {
                        Work_Day_Code: that.dataDetail.Work_Day_Code,
                        line: that.dataDetail.line
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    that.$http.urlpost('/Basic/WH/CreateShift', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.getView()
                            that.code = res.UniqueNum
                            that.getDetail(res.UniqueNum)
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    });
                } else {
                    let parm = that.dataDetail.line
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    that.$http.urlpost('/Basic/WH/UpdaeShift', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.getView()
                            that.getDetail(that.code)
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    });
                }
            },
            // 删除明细
            delLine(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.line.splice(that.selectData[i].index, 1);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            // 过滤年月日，只留时分秒
            filter(val){
                let timearr = val.replace(" ", ":").replaceAll("/","-").replaceAll(":", "-").split("-")
                return timearr[3] + ":" + timearr[4] + ""
            },
            getMyDate(row,type){
                let that = this
                let index = row.$index
                if(type == 1){
                    let date = row.row.Start_Time
                    let d = new Date(date);
                    let resDate = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()+' '+d.getHours()+':'+d.getMinutes()+':'+d.getSeconds();
                    that.dataDetail.line[index].Start_Time =  resDate;
                } else {
                    let date = row.row.End_Time
                    let d = new Date(date);
                    let resDate = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()+' '+d.getHours()+':'+d.getMinutes()+':'+d.getSeconds();
                    that.dataDetail.line[index].End_Time =  resDate;
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .off {
        background: #ff9c1c;
    }
    /deep/ .work{
        background: #a8fff7;
    }
    /deep/.el-calendar-table {
        width: 100%;
        height: 100%;
        &:not(.is-range) {
            //使不是本月的日期不可点击，不会跳转到其他月份
            td.next {
                pointer-events: none;
            }
            td.prev {
                pointer-events: none;
            }
        }
    }
</style>
